// extracted by mini-css-extract-plugin
module.exports = {"inner-shadow":"ProductViewVariants_inner-shadow__JP0pt"};